export default __webpack_public_path__ + "static/media/loading_animation_original.3aa1b391.gif";